import { useState,useEffect } from "react";

const useMedia=(query)=>{
    const[matches,setmatches]=useState(false);
    useEffect(()=>{
        const media=window.matchMedia(query);
        if(media.matches!==matches){
            setmatches(media.matches.matches)
        }
        const listerner=()=>setmatches(media.matches);
        window.addEventListener("resize",listerner)
        return ()=>window.addEventListener("resize",listerner)
    },[matches,query])

    return matches
}

export default useMedia;